import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Container, Button, Row, Col, Form, FormGroup, Label, Input, Alert } from 'reactstrap';
import { createEvent } from '../../redux/actions/UserActions'
import { Redirect } from 'react-router-dom'

class NewEvent extends Component {
  state = {
    title: '',
    date: null,
    description: '',
    location: ''
  }

  handleChange = (e) => {
      this.setState({
          [e.target.id]: e.target.value
      })
  }

  handleSubmit = (e) => {
      e.preventDefault();
      this.props.createEvent(this.state);
  }

  render() {
    console.log(window.location)
    if (!this.props.auth.uid) return <Redirect to='/login' />
    return (
      <Container >
      <Row>
      <Col xs='12' md={{ size: 8, offset: 2 }}>
      {this.props.eventID ?

      // Show alert if submission was successful
      (<Alert className='text-center'>
        <h3>Awesome! Your event is live.</h3>
        <h3><small class="text-muted">Share: <Link to={`/event/${this.props.eventID}`}  style={{ color: 'gray' }}>
          {window.location.host}/event/{this.props.eventID}
        </Link></small></h3>
      </Alert>) 

      // Display form if submission has not occured
      : (<div>
          <h1 className="text-center">New Event </h1><br/>
          <Form>
            <FormGroup>
              <Label for='title'><h4>Title</h4></Label>
              <Input type='text' name='title' id='title' onChange={this.handleChange} />
            </FormGroup><br/>
            <FormGroup>
              <Label for='date'><h4>Date</h4></Label>
              <Input type='date' name='date' id='date' onChange={this.handleChange} />
            </FormGroup><br/>
            <FormGroup>
              <Label for='location'><h4>Location</h4></Label>
              <Input type='text' name='location' id='location' onChange={this.handleChange} />
            </FormGroup><br/>
            <FormGroup>
              <Label for="description"><h4>Description</h4></Label>
              <Input type="textarea" name="description" id="description" onChange={this.handleChange} />
            </FormGroup><br/>
            <div className='text-center'>
              <Button color='success' size='lg' onClick={this.handleSubmit}>Create</Button>
            </div>
          </Form>
      </div>)}
      </Col>
      </Row><br/><br/>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    eventID: state.user.eventID
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
      createEvent: (info) => dispatch(createEvent(info))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewEvent)
